module.exports = __webpack_public_path__ + "f180b9dc89772ba068a10845677fd748.pdf";